var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("translates", {
    attrs: {
      item: this.modif,
      item_id: parseInt(_vm.modif.id),
      item_type: "modifier",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }